import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

import { ActivatedRoute, Router } from "@angular/router";
import { AppUtils } from "../../../../shared/app-utils";
import { SearchService } from "../../../search.service";
import { Filter } from "../../filters/filter-block/filter-item/filter";
import { AppConfigService } from "../../../../config/app-config.service";
import { AppConfig } from "../../../../config/app-config";
import { RichSearchList } from "../../rich-search-list";
import { FiltersService } from "../../filters/filters.service";
import { HtmlUtilsService } from "../../../../html-utils/html-utils.service";
import { SearchPageInterface } from "./search-page-interface";
import { TranslateService } from "../../../../shared/translate.service";

@Component({
  selector: "app-pagination",
  templateUrl: "./pagination.component.html",
  styleUrls: ["./pagination.component.css"],
})
export class PaginationComponent implements OnInit {
  @Input() showLeft: boolean = true;

  @Input() searchResult: RichSearchList;

  @Input() facets: Filter[];

  @Input() showMoreOnMobile = false;

  @Input() showMoreLoadingIndicator = false;

  @Output() loadMoreFromPageEmitter = new EventEmitter<SearchPageInterface>();

  appConfig: AppConfig = new AppConfig();

  constructor(
    public translateService: TranslateService,
    private router: Router,
    private searchService: SearchService,
    private appConfigService: AppConfigService,
    private route: ActivatedRoute,
    private filtersService: FiltersService,
    public htmlUtils: HtmlUtilsService
  ) {}

  ngOnInit() {
    this.appConfig = this.appConfigService.getConfig();
  }

  onPageChange(page: string) {
    if (+page >= this.searchResult.totalPages) {
      this.searchResult.pageNumber = this.searchResult.totalPages;
      this.goToPage(this.searchResult.totalPages);
    } else if (+page < 1) {
      this.searchResult.pageNumber = 1;
      this.goToPage(this.searchResult.pageNumber);
    } else {
      this.goToPage(+page);
    }
  }

  onPageSizeChange() {
    this.goToPage(1);
  }

  hasNext() {
    return this.searchResult.totalPages >= this.searchResult.pageNumber + 1;
  }

  hasPrev() {
    return this.searchResult.pageNumber - 1 >= 1;
  }

  goToNext() {
    this.goToPage(this.searchResult.pageNumber + 1);
  }

  goToPrev() {
    this.goToPage(this.searchResult.pageNumber - 1);
  }

  loadMore() {
    this.loadMoreFromPageEmitter.emit(
      this.createPageParams(this.searchResult.pageNumber)
    );
  }

  private goToPage(page: number) {
    let currentPage = AppUtils.getCurrentPage();

    this.router
      .navigate([HtmlUtilsService.getSearchUrl(currentPage)], {
        queryParams: this.createPageParams(page),
      })
      .then((value) => window.scrollTo(0, 0))
      .catch((value) => window.scrollTo(0, 0));
  }

  private createPageParams(page: number): SearchPageInterface {
    let queryParams = {
      phrase: this.searchResult.phrase,
      page: page,
      pageSize: this.searchResult.pageSize,
      filters: this.filtersService.filtersToString(),
      sort: undefined,
      searchInText: undefined,
      queryId: undefined,
    };

    let sort = this.route.snapshot.queryParams.sort;

    if (sort) {
      queryParams["sort"] = sort;
    }

    if (this.searchResult.sortField) {
      queryParams["sort"] = this.searchResult.sortField;
    }

    if (this.route.snapshot.queryParamMap.get("searchInText")) {
      queryParams["searchInText"] =
        this.route.snapshot.queryParamMap.get("searchInText");
    }
    if (this.route.snapshot.queryParamMap.get("collectionId")) {
      queryParams["collectionId"] =
        this.route.snapshot.queryParamMap.get("collectionId");
    }

    if (this.route.snapshot.queryParamMap.get("queryId")) {
      queryParams["queryId"] = this.route.snapshot.queryParamMap.get("queryId");
    }

    return queryParams;
  }
}
